import { useLocation } from 'react-router-dom';
import Progress from '../../components/progress';
import './style.css';
import React, { useEffect, useState } from 'react'
import { getUserInfo, logout } from '../../libs/lib';
import { Button, FormControl, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { SESSION_EXPIRED_CODE } from '../../config';
import { http_request } from '../../libs/connection';

function Account() {
  const location = useLocation();
  const { pathname } = location;
  const [is_loading, setLoadingStatus] = useState(false);
  const user_info = getUserInfo();
  const [password, setPassword] = useState('');
  const [password_editor_show, showPasswordEditor] = useState(false);
  const [success_toast_show, showSuccessToast] = useState(false);
  const [error_toast_show, showErrorToast] = useState(false);
  const [error_message, setErrorMessage] = useState('');

  useEffect(()=>{
    
  }, [pathname]);


  function resetPassword(){
    let params = {
        new_password: password
    };
    setLoadingStatus(true);
    http_request('/company/password', 'POST', params).then(res=>{
      setLoadingStatus(false);
      if(res.success){
          showSuccessToast(true);
          showPasswordEditor(false);
      }else if(res.message === SESSION_EXPIRED_CODE){
          logout();
      }else{
          setErrorMessage(res.message);
          showErrorToast(true);
      }
    });
  }
  return (
    <div id="page-account" className='page d-flex flex-column align-items-center justify-content-center'>
      <Progress show={is_loading} variant="primary" />
      <Modal
          centered
          show={password_editor_show}
          onHide={()=>{ showPasswordEditor(false); }}
      >
          <Modal.Header closeButton>
              <span>重设密码</span>
          </Modal.Header>
          <Modal.Body>
              <FormControl
                  type='password'
                  value={password}
                  onChange={e=>{ setPassword(e.currentTarget.value); }}
                  placeholder='输入密码'
              />
          </Modal.Body>
          <Modal.Footer className='d-flex align-items-center justify-content-between'>
              <Button 
                  size="sm" 
                  variant='danger'
                  onClick={()=>{ showPasswordEditor(false); }}
              >取消</Button>
              <Button 
                  size="sm" 
                  variant='success' 
                  disabled={password.length === 0 || is_loading} 
                  onClick={()=>{ resetPassword(); }}
              >重设密码</Button>
          </Modal.Footer>
      </Modal>
      <ToastContainer 
          position='middle-bottom'
          style={{ zIndex: 1056 }}
          >
          <Toast 
              show={success_toast_show} 
              onClose={()=>{ showSuccessToast(false); }}
              delay={2000}
              autohide
              bg="success"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">更新完成</strong>
              </Toast.Header>
              <Toast.Body>已重设密码</Toast.Body>
          </Toast>
      </ToastContainer>
      <ToastContainer
          position='middle-bottom'
          style={{ zIndex: 1056 }}
      >
          <Toast 
              show={error_toast_show} 
              onClose={()=>{ showErrorToast(false); }}
              delay={3000}
              autohide
              bg="danger"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">更新失败</strong>
              </Toast.Header>
              <Toast.Body>{error_message}</Toast.Body>
          </Toast>
      </ToastContainer>
      <div id="user-info" className='p-3 bg-white d-flex flex-column align-items-center justify-content-center'>
        <h3>帐号资讯</h3>
        <table className='mb-5'>
          <tbody>
            <tr>
              <td>帐号</td>
              <td>{user_info.account}</td>
            </tr>
            <tr>
              <td>名称</td>
              <td>{user_info.name}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{user_info.email}</td>
            </tr>
            <tr>
              <td colSpan={2}><Button variant='danger' size="sm" onClick={()=>{ showPasswordEditor(true); }}>重设密码</Button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Account